import { render, staticRenderFns } from "./SnapshotChangeRequestsList.vue?vue&type=template&id=c8560162"
import script from "./SnapshotChangeRequestsList.vue?vue&type=script&lang=js"
export * from "./SnapshotChangeRequestsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports